module.exports = __webpack_public_path__ + "static/media/cross.a470f8fd.svg";